import React from 'react';
import { BackIcon } from '@lt/components/icons-react/auth';
import classnames from 'classnames';
import styles from './backButton.module.css';

interface Props {
  onClick?: () => void;
  className?: string;
}

export const BackButton: React.FC<Props> = ({ onClick, className }) => (
  <button
    className={classnames(styles.container, className)}
    type="button"
    onClick={onClick}
  >
    <BackIcon width={24} height={24} />
  </button>
);
